import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    directory: {},
    loading: false,
    tabLoading: false,
    showingUserMessage: false,
    userMessage: {},
    sort: {
      key: null,
      order: 0,
      id: null,
    },
    saving: 'idle',
    saveProgress: 0,
    saveTotalItems: 7,
    saveText: 'Saving changes',
  },

  getters: {
    user(state) {
      return state.user;
    },

    directory(state) {
      return state.directory;
    },

    loading(state) {
      return state.loading;
    },

    saving(state) {
      return state.saving;
    },

    savePercent(state) {
      return (state.saveProgress / state.saveTotalItems) * 100;
    },

    tabLoading(state) {
      return state.tabLoading;
    },

    userMessage(state) {
      if (state.showingUserMessage) {
        return state.userMessage;
      }
      return false;
    },
  },

  mutations: {
    setSaving(state, saving) {
      state.saving = saving;
    },

    addSaveProgress(state) {
      if (state.saveProgress < state.saveTotalItems) {
        state.saveProgress += 1;
      }
    },

    resetSaveProgress(state) {
      state.saveProgress = 0;
    },

    setSaveText(state, text) {
      state.saveText = text;
    },

    setSaveTotalItems(state, num) {
      state.saveTotalItems = num;
    },

    setUser(state, data) {
      state.user = data;
    },

    setApi(state, data) {
      state.api = data;
    },

    setUserMessage(state, payload) {
      return (state.userMessage = payload);
    },

    setUserMessageShowing(state, showing) {
      return (state.showingUserMessage = showing);
    },

    setDirectory(state, data) {
      state.directory = data;
    },

    setLoading(state, value) {
      state.loading = value;
    },

    setTabLoading(state, value) {
      state.tabLoading = value;
    },

    setSort(state, sort) {
      state.sort.key = sort.key;
      state.sort.order = sort.order;
      state.sort.id = sort.id;
    },
    setSortOrder(state, order) {
      state.sort.order = order;
    },
  },

  actions: {
    setLoading({ commit }, value) {
      commit('setLoading', value);
    },

    setUser({ commit }, data) {
      commit('setUser', data);
    },

    setApi({ commit }, data) {
      commit('setApi', data);
    },

    setTabLoading({ commit }, value) {
      commit('setTabLoading', value);
    },

    async showUserMessage({ commit }, payload) {
      commit('setUserMessage', payload);
      commit('setUserMessageShowing', true);

      if (!payload.persist) {
        setTimeout(async () => {
          commit('setUserMessageShowing', false);
          commit('setUserMessage', null);
        }, 3000);
      }
    },

    hideUserMessage({ commit }) {
      commit('setUserMessageShowing', false);
    },
  },

  modules: {},
});
